export const TYPING_DEBOUNCE_INTERVAL = 2000;
